import React, {PropTypes} from 'react';
import moment from 'moment';
import DisplayIf from 'shared/DisplayIf.jsx';
import CaptainPaymentEntryListContainer from './CaptainPaymentEntryListContainer.jsx';
import {formatCurrency} from 'shared/util/formatCurrency';
Number.prototype.formatCurrency = formatCurrency;

const CaptainPaymentListItem = ({
  acceptedByEmail,
  amountPaid,
  displayEntries,
  entriesQty,
  notes,
  checkNumber,
  creditCardTransactionId,
  onViewEntriesClick,
  onPrintConfirmationClick,
  paymentDateTime,
  paymentId,
  paymentMethod,
  tournamentName,
  tournamentTimeZoneName
}) => (
  <div className="list-group-item-labeled">
    <div className="list-group-item-labeled-child"
        style={{ width: 250, "margin-bottom": 10}}>
      <span>{'Payment Date'}</span>
      <span>{`${moment.parseZone(paymentDateTime).format('MMM Do, YYYY, hh:mm A')} (${tournamentTimeZoneName})`}</span>
    </div>
    <div className="list-group-item-labeled-child"
        style={{ width: 125, "margin-bottom": 10}}>
      <span>{'Amount Paid'}</span>
      <span>{`$${amountPaid.formatCurrency(2)}`}</span>
    </div>
    <div className="list-group-item-labeled-child"
        style={{ width: 200, "margin-bottom": 10}}>
      <span>{'Tournament'}</span>
        <span>{tournamentName || '-'}</span>
    </div>
    <div className="list-group-item-labeled-child"
        style={{ width: 100, "margin-bottom": 10}}>
      <span>{'Payment Method'}</span>
      <span>{paymentMethod || '-'}</span>
    </div>
    <div className="list-group-item-labeled-child"
        style={{ width: 210, "margin-bottom": 10}}>
      <span>{'Accepted By'}</span>
      <span>{acceptedByEmail || '-'}</span>
    </div>
    <div className="list-group-item-labeled-child"
        style={{ width: 140, "margin-bottom": 10 }}>
      <button className="btn btn-link"
        onClick={() => onViewEntriesClick(paymentId)}>{`View Entries (${entriesQty})`}</button>
      <DisplayIf condition={amountPaid > 0}>
        <button className="btn btn-link"
          onClick={() => onPrintConfirmationClick(paymentId)}>{`Print Confirmation`}</button>
      </DisplayIf>
      </div>
      {checkNumber
        ? <div className="list-group-item-labeled-child"
               style={{ width: 210, "margin-bottom": 10 }}>
            <span>{'Check Number'}</span>
            <span>{checkNumber}</span>
          </div>
        : null
      }
    {creditCardTransactionId
        ? <div className="list-group-item-labeled-child"
               style={{ width: 260, "margin-bottom": 10 }}>
            <span>{'Transaction ID'}</span>
            <span>{creditCardTransactionId}</span>
          </div>
        : null
      }
    {notes
        ? <div className="list-group-item-labeled-child has-long-text full-width">
          <span>{'Notes'}</span>
          <span>{notes}</span>
        </div>
        : null
      }
    {displayEntries
      ? <CaptainPaymentEntryListContainer />
      : null
    }
  </div>
);

CaptainPaymentListItem.propTypes = {
  acceptedByEmail: PropTypes.string,
  amountPaid: PropTypes.number,
  displayEntries: PropTypes.bool,
  entriesQty: PropTypes.number,
  notes: PropTypes.string,
  checkNumber: PropTypes.string,
  creditCardTransactionId: PropTypes.string,
  onViewEntriesClick: PropTypes.func,
  onPrintConfirmationClick: PropTypes.func,
  paymentDateTime: PropTypes.string.isRequired,
  paymentId: PropTypes.string.isRequired,
  paymentMethod: PropTypes.string,
  tournamentName: PropTypes.string,
  tournamentTimeZoneName: PropTypes.string
};

CaptainPaymentListItem.defaultProps = {
  acceptedByEmail: '',
  amountPaid: 0,
  displayEntries: false,
  entriesQty: 0,
  notes: '',
  paymentDateTime: '',
  paymentId: '',
  paymentMethod: '',
  tournamentName: '',
  tournamentTimeZoneName: ''
};

export default CaptainPaymentListItem;



// WEBPACK FOOTER //
// ./src/features/admin/captainDetail/CaptainPaymentListItem.jsx